import { UPDATE_CARREGADOR } from "redux/constants/Carregador";

export const setCarregador = (id, numeroSerie) => {
	return {
		type: UPDATE_CARREGADOR,
		id: id,
		numero_serie: numeroSerie,
	};
};
